import React from 'react';
import omit from 'lodash/omit';
import Attachment from './Attachment';
const Dragger = props => {
    const { style, height, children, attachmentChildren } = props;
    const dragBoxRender = children;
    const omitProps = omit(props, ['children']);
    return React.createElement(Attachment, Object.assign({}, omitProps, { dragUpload: true, dragBoxRender: dragBoxRender, style: { ...style, height } }), attachmentChildren);
};
export default Dragger;
